import {gql} from 'apollo-boost';

export const GET_PREFIXES = gql`
  query getPrefixes{
    getPrefixes {
      id
      nameLocal
      nameEng
    }
  }
`;

export const GET_PREFIX = gql`
  query getPrefix($id : ID!){
    getPrefix (
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const ADD_PREFIX = gql`
  mutation addPrefix(
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addPrefix(
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_PREFIX = gql`
  mutation updatePrefix(
    $id: ID!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updatePrefix(
      id: $id
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_PREFIX = gql`
  mutation deletePrefix($id: ID!) {
    deletePrefix(
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

